import { useEffect, useState } from "react";
import { ExternalIntegrationModel } from "../services";
import { normalizeExternalIntegrationList } from "../utils/externalIntegration";

/**
 * Loads integrations of type fetch_order_by_id for the new-order import flow.
 * When disabled, skips the request (e.g. edit flow without import).
 */
export function useFetchOrderIntegrations(enabled = true) {
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(Boolean(enabled));

  useEffect(() => {
    if (!enabled) {
      setIntegrations([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await ExternalIntegrationModel.get();
        const raw = res.data?.data ?? res.data;
        const all = normalizeExternalIntegrationList(
          Array.isArray(raw) ? raw : []
        );
        const fetchOnly = all.filter(
          (row) => row.type === "fetch_order_by_id" && row.url
        );
        if (!cancelled) setIntegrations(fetchOnly);
      } catch {
        if (!cancelled) setIntegrations([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return { integrations, loading };
}
